import { apiUrl, siteRoot} from "./env"
import wx from 'weixin-js-sdk'
import iwx from '@/config/WeixinSdk.js'
import router from '@/router'
import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { ImagePreview } from 'vant';
import base64_encode from './base64_encode'
import {Amap} from '@/config/AMap'
import {GMap} from '@/config/GMap'
import {BMap} from '@/config/BMap'
import cloudApp from '@/config/cloudapp.js'
import h5app from '@/config/h5app'
import {maJia} from '@/config/maJia'
let ibs = require('js-base64').Base64;

var util = {

	h5Share: function() {
		if(!util.ish5app()) {
			return false;
		}
		h5app.init({});
		h5app.share();
	},

	h5appSingleShare: function(plateform) {
		if(!util.ish5app()) {
			return false;
		}
		h5app.init({});
		h5app.singleShare(plateform);
	},

	clearCache: function() {
		if(util.ish5app()) {
			h5app.init({});
			h5app.clearCache();
		} else if(util.isGlala()){
			api.clearCache();
		}
		return true;
	},

	scan: function() {
		if(!util.ish5app()) {
			return false;
		}
		h5app.init({});
		h5app.scan();
	},

	setWXTitle: function (title) {
		if(!title) {
			return false;
		}
		document.title = title
		var mobile = navigator.userAgent.toLowerCase()
		if (/iphone|ipad|ipod/.test(mobile)) {
			var iframe = document.createElement('iframe')
			iframe.style.display = 'none'
			// 替换成站标favicon路径或者任意存在的较小的图片即可
			iframe.setAttribute('src', '/favicon.ico')
			var iframeCallback = function () {
				setTimeout(function () {
					iframe.removeEventListener('load', iframeCallback)
					document.body.removeChild(iframe)
				}, 0)
			}
			iframe.addEventListener('load', iframeCallback)
			document.body.appendChild(iframe)
		}
	},

	imeiqia: function() {
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.src = util.getFullUrl('system/common/js/meiqia');
		document.head.appendChild(script);
	},

	jsauth: function() {
		return true;
	},

	isMenuActive: function(item) {
		if(!item) {
			return false;
		}
		let page = window.location.href.split('#/');
		if(page && page[1]) {
			page = page[1];
		}
		if(item.indexOf('/') == 0) {
			page = '/' + page;
		}
		if(page.indexOf(item) == 0) {
			return true;
		}
		return false;
	},

	jsPreviewImage: function(item, index) {
		if(typeof item == 'string') {
			item = [item];
		}
		if(!index) {
			index = 0;
		}
		if(util.isWeixin()) {
			wx.previewImage({
				current: item[index], // 当前显示图片的http链
				urls: item // 需要预览的图片http链接列表
			});
		} else {
			ImagePreview(item, index);
		}
	},

	image1: function(obj, callback, options) {
		var defaultOptions = {
			fileNum: 1,
			channel: 'wap'
		};
		var options = Object.assign({}, defaultOptions, options);
		if(util.isWeixin() || options.channel == 'weixin') {
			wx.chooseImage({
				count: options.fileNum,
				sizeType: ['compressed'],
				sourceType: ['album', 'camera'],
				success: function (res) {
					var localIds = res.localIds;
					if(localIds.length > 0) {
						for(var i = 0; i < localIds.length; i++) {
							//$.showIndicator();
							wx.uploadImage({
								localId: localIds[i],
								isShowProgressTips: 0,
								success: function (res) {
									var serverId = res.serverId;
									util.request({
										url: 'system/common/file/image',
										data: {channel: 'weixin', media_id: serverId}
									}).then((res) => {
										let result = res.data.message;
										if(result.errno == 0) {
											if(typeof callback == 'function') {
												callback(obj, result);
											}
										} else {
											util.$toast('上传文件失败, 具体原因:' + result.message, '', 1000);
										}
									});
								},
								fail: function() {}
							});
						}
					}
				}
			});
		} else {

		}
	},

	image: function(params) {
		var options = params.options;
		var obj = params.obj;
		if(options.channel == 'h5') {
			let fileElm = obj.target;
			if(fileElm.files && fileElm.files.length > 0) {
				let url = util.getFullUrl('c=utility&a=file&do=upload&type=image&thumb=1');
				Toast.loading({
					message: '上传中',
					forbidClick: true,
				});
				for(var i = 0; i < fileElm.files.length; i++) {
					let pars = new FormData();
					pars.append('file', fileElm.files[i]);
					axios.post(url, pars).then((res) => {
						Toast.clear();
						let result = res.data;
						if(result.errno) {
							if(result.message) {
								alert('上传文件失败, 具体原因:' + result.message);
							} else {
								alert('上传文件失败, 具体原因:' + result.error.message);
							}
							return;
						}
						if(typeof params.success == 'function') {
							params.success(obj, result);
						}
					});
				}
			}
		}
	},

	imageCompress: function(fileOjb, oversize, callback) {
		if(fileOjb.size > oversize) {
			var reader = new FileReader();
			reader.onload = function (e) {
				var data = e.target.result;
				//加载图片获取图片真实宽度和高度
				var image = new Image();
				image.onload = function () {
					var width = image.width;
					var height = image.height;
					var scale = fileOjb.size / oversize;
					width = parseInt(width / scale);
					height = parseInt(height / scale);
					lrz(fileOjb, {
						width: width,
						height: height,
						/*quality: 0.7,
						filedName: 'file',*/
					}).then(function(rst) {
						//将blob转为file
						var file = new window.File(
							[rst.file],
							rst.origin.name,
							{type: rst.origin.type}
						);
						if(typeof callback === 'function') {
							callback(file)
						}
					}).catch(function(error) {
						//失败时执行
						console.log('图片压缩失败', error);
					}).always(function() {
						//不管成功或失败，都会执行
					})
				};
				image.src= data;
			}
			reader.readAsDataURL(fileOjb);
		} else {
			if(typeof callback === 'function') {
				callback(fileOjb)
			}
		}
	},

	jsAlert: function(params) {
		let option = {};
		if(typeof params == 'string') {
			option.message = params;
		} else {
			if(params.title) {
				option.title = params.title;
			}
			if(params.message) {
				option.message = params.message;
			}
		}
		Dialog.alert(option).then(() => {});
		return true;
	},

	jsLocation: function(item) {
		var type = item.type ? item.type : 'wap';
		var MapType = item.MapType ? item.MapType : util.getStorage('MapType');

		var lat = parseFloat(item.lat), lng = parseFloat(item.lng);
		if(!lat || !lng) {
			util.$toast('请先设置地址经纬度');
			return false;
		}
		var params = {
			latitude: lat,
			longitude: lng
		};
		if(item.scale) {
			params.scale = item.scale;
		}
		if(item.name) {
			params.name = item.name;
		}
		if(item.address) {
			params.address = item.address;
		}
		if(type == 'wap') {
			if(util.isWeixin()) {
				wx.openLocation(params);
			} else {
				if(MapType == 'google') {
					let query = {
						api: 1,
						query: lat + ',' + lng
					};
					window.location.href = "https://www.google.com/maps/search/?" + util.toQueryString(query);
				} else if(MapType == 'baidu') {
					let query = {
						location: lat + ',' + lng,
						title: params.name,
						content: params.address,
						output: 'html',
					}
					window.location.href = "http://api.map.baidu.com/marker?" + util.toQueryString(query);
				} else {
					let query = {
						q: params.latitude+","+params.longitude,
						name: params.name,
						address: params.address,
					};
					window.location.href = "http://m.amap.com/?" + util.toQueryString(query);
				}
			}
		}

		return;
	},

	jsTel: function(mobile) {
		console.log('tel:' + mobile);
		window.location.href = 'tel:' + mobile;
		return;
	},

	jsUrl: function(url, query, redirectFunction) {
		if(!url) {
			return;
		}
		if(url == 'close') {
			if(util.isWeixin()) {
				wx.closeWindow();
			}
			return;
		} else if(url == 'back') {
			router.back();
			return;
		}
		if(url.indexOf('https://') == 0 || url.indexOf('http://') == 0) {
			window.location.href = url;
			return;
		}
		var urls = url.split(':');
		console.log(urls)
		if(urls.length == 1){
			if(url == 'refresh') {
				window.location.reload();
				return;
			}
			let hasi = util.getUrlParam(url, 'i');
			if(url.indexOf('/') != 0) {
				url = '/' + url;
			}
			if(!query || (query && typeof query != 'object') || (query && typeof query === 'object' && !(query instanceof Object))) {
				query = {}
			}
			if(!hasi) {
				url = util.getUrl({path: url, query: query});
			} else {
				let queryKeys = Object.keys(query)
				if(queryKeys.length > 0) {
					if(url.indexOf('?') == -1) {
						url = url + '?'
					} else {
						url = url + '&';
					}
					var i = 0
					for(var x in query) {
						i++;
						url += x + '=' + query[x];
						if(i < queryKeys.length) {
							url += '&'
						}
					}
				}
			}

			var redirectArr = ['push', 'replace'];
			if(!redirectFunction || redirectArr.indexOf(redirectFunction) == -1) {
				redirectFunction = 'push';
			}
			router[redirectFunction](url);
			return;
		} else {
			if(urls[0] == 'webview') {
				window.location.href = url.substring(8);
			} else if(urls[0] == 'tel'){
				window.location.href = url;
			} else if(urls[0] == "miniProgram") {
				if(!util.isGlala()) {
					return false;
				}
				var datas = urls[1].split(',');
				var params = {};
				for(var i = 0; i < datas.length; i++) {
					var item = datas[i].split('_');
					var key = item[0];
					var value = item.slice(1).join('_');
					params[key] = value;
				}
				util.jsMiniProgram(params);
			} else if(urls[0] == 'wx') {
				if(urls[1] == 'scanCode') {
					if(util.isWeixin()) {
						wx.scanQRCode();
					} else if(util.isGlala()) {
						util.scanQRCode();
					}
				}
			} else if(urls[0] == 'weixinchat') {
				var weixinchat = urls.pop();
				weixinchat = weixinchat.split(',');
				if(weixinchat) {
					if(weixinchat[0]) {
						var chat_url = 'https:' + weixinchat[0];
						window.location.href = chat_url;
					}
				}
			}
		}
	},

	jsMiniProgram: function(params) {
		var miniParams = {
			userName: params.originid,
			fail: function(errno, message) {
				util.$toast('拉起小程序失败，错误码' + errno + '，错误信息：' + message);
			}
		};
		if(params.path) {
			miniParams['path'] = params.path;
		}
		cloudApp.launchMiniProgram(miniParams)
		return;
	},

	scanQRCode(params = {}) {
		cloudApp.scanQRCode(params);
	},

	rmpay: function(params) {
		if(!params.pay_type) {
			params.pay_type = 'WECHATPAY_MY';
		}
		if(!params.order_type) {
			return false;
		}
		if(!params.order_id) {
			return false;
		}
		var postData = {
			pay_type: 'rm-' + params.pay_type,
			order_type: params.order_type,
			id: params.order_id,
		};
		util.request({
			url: 'system/paycenter/pay',
			data: postData,
			showLoading: true
		}).then((result) => {
			var result = result.data.message;
			console.log(result);
			if(result.errno) {
				util.$toast(result.message);
				params.vue.submitDisabled = false;
				return false;
			}
			var payurl = result.message.url;
			window.location.href = payurl;
			return false;
		})
	},

	stripepay: function(params) {
		if(!params.order_type) {
			return false;
		}
		if(!params.order_id) {
			return false;
		}
		var vueRouter = router;
		var postData = {
			pay_type: params.pay_type,
			order_type: params.order_type,
			id: params.order_id
		};
		util.request({
			url: 'system/paycenter/pay',
			data: postData,
			showLoading: true
		}).then((result) => {
			var result = result.data.message;
			console.log(result);
			if(result.errno) {
			util.$toast(result.message);
			params.vue.submitDisabled = false;
			return false;
			}
	
			var wheel_url = '';
			if(result.wheel_url) {
				wheel_url = result.wheel_url;
			} else if(result.message.wheel_url) {
				wheel_url = result.message.wheel_url;
			}
			if(result.pay_type) {
				params.pay_type = result.pay_type;
			}
			result = result.message;
			var routers = {
			takeout: {
				url_detail: {path: '/pages/order/detail', query: {id: postData.id}}
			},
			mall: {
				url_detail: {path: '/mall/pages/order/detail', query: {id: postData.id}}
			},
			deliveryer_award: {
				url_detail: {path: '/pages/order/index', query: {}}
			},
			errander: {
				url_detail: {path: '/plugin/pages/paotui/detail', query: {id: postData.id}}
			},
			deliveryCard: {
				url_detail: {path: '/package/pages/deliveryCard/index'}
			},
			errander_recharge: {
				url_detail: {path: '/plugin/pages/paotui/store/finance/yucunjin'}
			},
			recharge: {
				url_detail: {path: '/pages/member/mine'}
			},
			paybill: {
				url_detail: {path: '/plugin/pages/paybill/detail', query: {id: postData.id}}
			},
			creditshop: {
				url_detail: {path: '/plugin/pages/creditshop/list'}
			},
			freelunch: {
				url_detail: {path: '/package/pages/freelunch/partakeSuccess'}
			},
			seckill: {
				url_detail: {path: '/pages/seckill/orderList'}
			},
			vip: {
				url_detail: {path: '/pages/vip/index'}
			},
			recharge_vip: {
				url_detail: {path: '/pages/member/mine'}
			},
			peerpay: {
				url_detail: {path: '/pages/public/peerpay/paylist', query: {payinfo_id: postData.id}}
			},
			mealRedpacket_plus: {
				url_detail: {path: '/package/pages/mealRedpacket/orderplus'}
			},
			mealRedpacket: {
				url_detail: {path: '/package/pages/mealRedpacket/meal'}
			},
			gohome: {
				url_detail: {path: '/gohome/pages/order/detail', query: {id: postData.id}}
			},
			tongcheng: {
				url_detail: {path: '/gohome/pages/tongcheng/detail', query: {trade_id: postData.id}}
			},
			haodian: {
				url_detail: {path: '/gohome/pages/haodian/application'}
			},
			svip: {
				url_detail: {path: '/package/pages/svip/mine'}
			},
			vipRedpacket: {
				url_detail: {path: '/plugin/pages/vipRedpacket/index'}
			},
			deposit: {
				url_detail: {path: '/mall/pages/deposit/detail', query: {id: postData.id}}
			},
			};
			var router = routers[params.order_type];
			if(params.order_type == 'gohome' && params.extra) {
			if(params.extra.order_type == 'pintuan' && params.extra.is_team == 1) {
				router.url_detail = {path: '/gohome/pages/pintuan/share', query: {id: params.extra.goods_id, team_id:	params.extra.team_id}};
			}
			}
			router.url_detail = util.getUrl(router.url_detail);
			if(wheel_url) {
				if(wheel_url.indexOf('https://') > -1 || wheel_url.indexOf('http://') > -1) {
					router.url_detail = wheel_url;
				} else {
					router.url_detail = util.getUrl({path: wheel_url});
				}
			}
			//支付成功后页面跳转
			if(router) {
			util.$toast('支付成功', router.url_detail, 1500, 'replace');
			return true;
			}
			util.$toast('支付成功');
			return false;
		})
	},

	pay: function(params) {
		if(!params.pay_type) {
			params.pay_type = 'wechat';
		}
		if(!params.order_type) {
			return false;
		}
		if(!params.order_id) {
			return false;
		}
		var vueRouter = router;
		var postData = {
			pay_type: params.pay_type,
			order_type: params.order_type,
			id: params.order_id,
			repay: params.repay,
		};
		util.request({
			url: 'system/paycenter/pay',
			data: postData,
			showLoading: true
		}).then((result) => {
			var result = result.data.message;
			console.log(result);
			if(result.errno) {
				util.$toast(result.message);
				params.vue.submitDisabled = false;
				return false;
			}
			if(params.pay_type == 'peerpay' && params.order_type == 'takeout') {
				params.vue = '';
				util.$toast('快去找人代付', util.getUrl({path: '/pages/public/peerpay/index', query: {pid: result.message.pid}}), 1000);
				return;
			}
			var wheel_url = '';
			if(result.wheel_url) {
				wheel_url = result.wheel_url;
			} else if(result.message.wheel_url) {
				wheel_url = result.message.wheel_url;
			}
			if(result.pay_type) {
				params.pay_type = result.pay_type;
			}
			result = result.message;
			var routers = {
				takeout: {
					url_detail: {path: '/pages/order/detail', query: {id: postData.id}}
				},
				mall: {
					url_detail: {path: '/mall/pages/order/detail', query: {id: postData.id}}
				},
				deliveryer_award: {
					url_detail: {path: '/pages/order/index', query: {}}
				},
				errander: {
					url_detail: {path: '/plugin/pages/paotui/detail', query: {id: postData.id}}
				},
				deliveryCard: {
					url_detail: {path: '/package/pages/deliveryCard/index'}
				},
				errander_recharge: {
					url_detail: {path: '/plugin/pages/paotui/store/finance/yucunjin'}
				},
				recharge: {
					url_detail: {path: '/pages/member/mine'}
				},
				paybill: {
					url_detail: {path: '/plugin/pages/paybill/detail', query: {id: postData.id}}
				},
				creditshop: {
					url_detail: {path: '/plugin/pages/creditshop/list'}
				},
				freelunch: {
					url_detail: {path: '/package/pages/freelunch/partakeSuccess'}
				},
				seckill: {
					url_detail: {path: '/pages/seckill/orderList'}
				},
				vip: {
					url_detail: {path: '/pages/vip/index'}
				},
				recharge_vip: {
					url_detail: {path: '/pages/member/mine'}
				},
				peerpay: {
					url_detail: {path: '/pages/public/peerpay/paylist', query: {payinfo_id: postData.id}}
				},
				mealRedpacket_plus: {
					url_detail: {path: '/package/pages/mealRedpacket/orderplus'}
				},
				mealRedpacket: {
					url_detail: {path: '/package/pages/mealRedpacket/meal'}
				},
				gohome: {
					url_detail: {path: '/gohome/pages/order/detail', query: {id: postData.id}}
				},
				tongcheng: {
					url_detail: {path: '/gohome/pages/tongcheng/detail', query: {trade_id: postData.id}}
				},
				haodian: {
					url_detail: {path: '/gohome/pages/haodian/application'}
				},
				svip: {
					url_detail: {path: '/package/pages/svip/mine'}
				},
				vipRedpacket: {
					url_detail: {path: '/plugin/pages/vipRedpacket/index'}
				},
				deposit: {
					url_detail: {path: '/mall/pages/deposit/detail', query: {id: postData.id}}
				},
			};
			var router = routers[params.order_type];
			if(params.order_type == 'gohome' && params.extra) {
				if(params.extra.order_type == 'pintuan' && params.extra.is_team == 1) {
					router.url_detail = {path: '/gohome/pages/pintuan/share', query: {id: params.extra.goods_id, team_id:  params.extra.team_id}};
				}
			}
			router.url_detail = util.getUrl(router.url_detail);
			console.log('wheel_url', wheel_url);
			if(wheel_url) {
				if(wheel_url.indexOf('https://') > -1 || wheel_url.indexOf('http://') > -1) {
					router.url_detail = wheel_url;
				} else {
					router.url_detail = util.getUrl({path: wheel_url});
				}
			}
			console.log('url_detail', router.url_detail);
			if(params.pay_type == 'wechat') {
				if(!util.isGlala()) {
					if (typeof WeixinJSBridge == "undefined"){
						if( document.addEventListener ){
							document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
						}else if (document.attachEvent){
							document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
							document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
						}
					}else{
						onBridgeReady();
					}
					function onBridgeReady() {
						WeixinJSBridge.invoke(
							'getBrandWCPayRequest', {
								"appId": result.appId,     //公众号名称，由商户传入
								"timeStamp": result.timeStamp,         //时间戳，自1970年以来的秒数
								"nonceStr": result.nonceStr, //随机串
								"package": result.package,
								"signType": result.signType,         //微信签名方式：
								"paySign": result.paySign //微信签名
							},
							function (res) {
								if (res.err_msg == "get_brand_wcpay_request:ok") {
									if (typeof params.success == "function") {
										params.success(res);
										return false;
									}
									if (router) {
										util.$toast('支付成功', router.url_detail, 3000, 'replace');
										return false;
									}
									util.$toast('支付成功');
									return false;
								} else {
									params.vue.submitDisabled = false;
									if (res.err_msg == "get_brand_wcpay_request:cancel") {
										util.$toast('支付失败:您取消微信支付');
										return false;
									}
									util.$toast('支付失败:' + res.err_msg);
									return false;
								}
							}
						);
					}
				} else {
					var payParams = {
						apiKey: result.appid,
						orderId: result.prepayid,
						mchId: result.partnerid,
						nonceStr: result.noncestr,
						timeStamp: result.timestamp,
						package: result.package,
						sign: result.paySign,
						success: function() {
							util.$toast('支付成功', router.url_detail, 3000, 'replace');
							return false;
						},
						fail: function(errCode) {
							var message = {
								'1': 'apiKey值非法',
								'-1': '未知错误，可能的原因：签名错误、未注册APPID、项目设置APPID不正确、注册的APPID与设置的不匹配、其他异常等',
								'-2': '您取消微信支付',
							};
							params.vue.submitDisabled = false;
							util.$toast('支付失败:' + message[errCode]);
							return false;
						}
					};
					cloudApp.wxPay(payParams);
				}
				return true;
			} else if(params.pay_type == 'alipay') {
				if(util.isGlala()) {
					var payParams = {
						orderInfo: result.orderInfo,
						success: function() {
							util.$toast('支付成功', router.url_detail, 3000, 'replace');
							return false;
						},
						fail: function(errCode) {
							var message = {
								'4000': '订单支付失败',
								'5000': '重复请求',
								'6001': '您中途取消支付操作',
								'6002': '网络连接出错',
								'6004': '支付结果未知',
								'8000': '订单正在处理中',
							}
							params.vue.submitDisabled = false;
							util.$toast('支付失败:' + message[errCode]);
							return false;
						}
					};
					cloudApp.aliPayPlus(payParams);
					return;
				}
				if(!util.isWeixin()) {
					window.location.href = result.url;
				} else {
					params.vue = '';
					params.url_detail = base64_encode(JSON.stringify(router.url_detail));
					vueRouter.push(util.getUrl({path: '/pages/public/aliPay', query: params}));
					return;
				}
				return;
			} else if(params.pay_type == 'credit') {
				//余额支付和货到付款执行到这里， 一定是支付成功的状态
				if(typeof params.success == "function") {
					params.success(res);
					return false;
				}
			} else if(params.pay_type == 'delivery' || params.pay_type == 'finishMeal') {
				if(typeof params.success == "function") {
					params.success(res);
					return false;
				}
			}
			//支付成功后页面跳转
			if(router) {
				util.$toast('支付成功', router.url_detail, 1500, 'replace');
				return true;
			}
			util.$toast('支付成功');
			return false;
		})
	},

	wxLogin: function() {
		var params = {
			success: function(ret) {
				var data = {
					sns: 'wx',
					openid: ret.openid,
					nickname: ret.nickname,
					sex: ret.sex,
					headimgurl: ret.headimgurl,
					unionid: ret.unionid
				};
				util.request({
					url: 'wmall/auth/account',
					data: data,
					method: 'POST',
				}).then(function(res) {
					let result = res.data.message;
					if(result.errno) {
						util.$toast(result.message, '', 1000);
						return false;
					}
					result = result.message;
					util.setStorage('itoken', result.member.token);
					var redirct_url = window.redirct_url;
					if(!redirct_url || (redirct_url && redirct_url.path.indexOf('pages/auth/') != -1)) {
						redirct_url = {path: '/pages/home/index'};
					}
					router.replace(util.getUrl(redirct_url));
					return;
				})
			},
			fail: function(errType, errCode) {
				var message = {
					isInstalled: {
						'-1': '当前设备未安装微信客户端',
					},
					auth: {
						'-1': '未知错误',
						'0': '成功，用户同意',
						'1': '用户取消',
						'2': '用户拒绝授权',
						'3': '当前设备未安装微信客户端',
					},
					getToken: {
						'-1': '未知错误',
						'0': '成功',
						'1': 'apiKey值为空或非法',
						'2': 'apiSecret值为空或非法',
						'3': 'code值为空或非法',
						'4': '网络超时'
					},
					getUserInfo: {
						'-1': '未知错误',
						'0': '成功',
						'1': 'accessToken过期',
						'2': 'openId非法',
						'3': 'openId值为空',
						'4': 'accessToken值为空',
						'5': 'accessToken非法',
						'6': '网络超时',
					},
					refreshToken: {
						'-1': '未知错误',
						'0': '成功',
						'1': 'apiKey值为空或非法',
						'2': 'refreshToken值为空',
						'3': 'refreshToken非法',
						'4': '网络超时'
					}
				};
				util.$toast(errType + '错误:' + message[errType][errCode]);
				return;
			}
		};
		cloudApp.wxLogin(params);
	},

	wxShareWebpage: function(params) {
		if(window._share) {
			params = {
				scene: params.scene, //分享场景 取值范围：session会话 timeline朋友圈 favorite收藏
				title: window._share.title,
				description: window._share.desc,
				thumb: window._share.imgUrl,
				contentUrl: window._share.link,
			}
		}
		var shareParams = {
			scene: params.scene,
			title: params.title,
			description: params.description,
			thumb: params.thumb,
			contentUrl: params.contentUrl,
			success: function() {
				if(window._share && typeof window._share.success == 'function') {
					window._share.success();
					return;
				}
				util.$toast('分享成功');
			},
			fail: function(errType, errCode) {
				var message = {
					isInstalled: {
						'-1': '当前设备未安装微信客户端',
					},
					shareWebpage: {
						'-1': '未知错误',
						'0': '成功',
						'1': 'apiKey非法',
						'2': '用户取消',
						'3': '发送失败',
						'4': '授权拒绝',
						'5': '微信服务器返回的不支持错误',
						'7': '注册SDK失败',
					},
				};
				util.$toast(errType + '错误:' + message[errType][errCode]);
				return;
			}
		};
		cloudApp.wxShareWebpage(shareParams);
	},

	qqLogin: function() {
		var params = {
			success: function(ret) {
				var data = {
					sns: 'qq',
					openid: ret.openid,
					nickname: ret.nickname,
					sex: ret.sex,
					headimgurl: ret.headimgurl,
					unionid: ret.unionid
				};
				util.request({
					url: 'wmall/auth/account',
					data: data,
					method: 'POST',
				}).then(function(res) {
					let result = res.data.message;
					if(result.errno) {
						util.$toast(result.message, '', 1000);
						return false;
					}
					result = result.message;
					util.setStorage('itoken', result.member.token);
					var redirct_url = window.redirct_url;
					if(!redirct_url || (redirct_url && redirct_url.path.indexOf('pages/auth/') != -1)) {
						redirct_url = {path: '/pages/home/index'};
					}
					router.replace(util.getUrl(redirct_url));
					return;
				})
			},
			fail: function(errType, errMsg) {
				util.$toast(errType + '错误:' + errMsg);
				return;
			}
		};
		cloudApp.qqLogin(params);
	},

	getLocation: function(params = {successLocation, successAddress, fail: '', MapType: 'gaode', agentid: 0}) {
		var AMapGetLocation = function(params) {
			Amap().then(function(AMap) {
				var map = map, geolocation;
				if(!map) {
					map = new AMap.Map('allmap');
				}
				map.plugin('AMap.Geolocation', function() {
					geolocation = new AMap.Geolocation({
						enableHighAccuracy: true, //是否使用高精度定位，默认:true
						timeout: 10000
					});
					geolocation.getCurrentPosition();
					AMap.event.addListener(geolocation, 'complete', function(res){
						var point = res.position;
						var location = {
							lat: point.lat,
							lng: point.lng,
							location_x: point.lat,
							location_y: point.lng
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						var lnglatXY = [point.lng, point.lat]; //已知点坐标
						map.plugin('AMap.Geocoder', function() {
							var geocoder = new AMap.Geocoder();
							geocoder.getAddress(lnglatXY, function(status, result) {
								if (status === 'complete' && result.info === 'OK') {
									var obj = result.regeocode.addressComponent;
									var position = result.regeocode.formattedAddress;
									position = position.replace(obj.province, '');
									position = position.replace(obj.district, '');
									position = position.replace(obj.city, '');
									if(typeof params.successAddress == 'function') {
										params.successAddress({
											address: position,
											lat: point.lat,
											lng: point.lng,
											location_x: point.lat,
											location_y: point.lng,
											province: obj.province,
											city: obj.city,
											district: obj.district,
											township: obj.township
										});
									}
								}
							});
						});
					});
					AMap.event.addListener(geolocation, 'error', function(res){
						if(typeof params.fail == 'function') {
							console.log('使用高德地图获取定位失败')
							console.log(res)
							params.fail(res);
						}
					});
				});
			});
		};

		var BMapGetLocation = function(params) {
			BMap().then(function() {
				var geolocation = new BMapGL.Geolocation();
				//浏览器定位
				geolocation.getCurrentPosition(function(res){
					const status = this.getStatus();
					let lat, lng, location = {};
					if(status == BMAP_STATUS_SUCCESS){
						console.log('您的位置：' + res.point.lng + ',' + res.point.lat);
						lat = res.point.lat;
						lng = res.point.lng;
						location = {
							lat: lat,
							lng: lng,
							location_x: lat,
							location_y: lng
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						var myGeo = new BMapGL.Geocoder({extensions_town: true});
						myGeo.getLocation(new BMapGL.Point(lng, lat), function(result){
							if(result) {
								let obj = result.addressComponents;
								let point = result.point;
								let position = result.address;
								position = position.replace(obj.province, '');
								position = position.replace(obj.city, '');
								position = position.replace(obj.district, '');
								if(!position) {
									position = obj.district;
								}
								if(typeof params.successAddress == 'function') {
									params.successAddress({
										address: position,
										lat: point.lat,
										lng: point.lng,
										location_x: point.lat,
										location_y: point.lng,
										province: obj.province,
										city: obj.city,
										district: obj.district,
										township: obj.township
									});
								}
							}
						});
					} else {
						console.log('百度定位浏览器定位失败, 根据IP进行定位', status)
						//IP定位
						var myCity = new BMapGL.LocalCity();
						myCity.get(function(city) {
							lat = city.center.lat;
							lng = city.center.lng;
							location = {
								lat: lat,
								lng: lng,
								location_x: lat,
								location_y: lng
							};
							if(typeof params.successLocation == 'function') {
								params.successLocation(location);
							}

							var myGeo = new BMapGL.Geocoder({extensions_town: true});
							myGeo.getLocation(new BMapGL.Point(lng, lat), function(result){
								if(result) {
									let obj = result.addressComponents;
									let point = result.point;
									let position = result.address;
									position = position.replace(obj.province, '');
									position = position.replace(obj.city, '');
									position = position.replace(obj.district, '');
									if(!position) {
										position = obj.district;
									}
									if(typeof params.successAddress == 'function') {
										params.successAddress({
											address: position,
											lat: point.lat,
											lng: point.lng,
											location_x: point.lat,
											location_y: point.lng,
											province: obj.province,
											city: obj.city,
											district: obj.district,
											township: obj.township
										});
									}
								}
							});
						});
					}
				});
			})
		};

		var GMapGetLocation = function(params) {
			GMap().then(function(google) {
				if(navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function(position) {
						//alert('谷歌获取定位结果：' + JSON.stringify(position));
						util.slog('googleLocation', '谷歌获取定位结果', JSON.stringify(position));
						var location = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
							location_x: position.coords.latitude,
							location_y: position.coords.longitude
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						//坐标转换为地址
						var geocoder = new google.maps.Geocoder;
						var latlng = {lat: position.coords.latitude, lng: position.coords.longitude};
						geocoder.geocode({ 'location': latlng }, function (results, status) {
							//util.slog('googleLocation', '坐标转换为地址', JSON.stringify(results));
							//alert('谷歌坐标转换为地址：' + JSON.stringify(results));
							if(status == 'OK') {
								//util.slog('googleLocation', '坐标转换为地址结果', '', JSON.stringify(results));
								if(typeof params.successAddress == 'function') {
									params.successAddress({
										address: results[0].formatted_address,
										lat: position.coords.latitude,
										lng: position.coords.longitude,
										location_x: position.coords.latitude,
										location_y: position.coords.longitude
									});
								}
							}
						})
					}, function(res) {
						console.log('浏览器定位失败')
						util.slog('googleLocation', '顾客端定位失败', JSON.stringify(res));
						params.fail(res);
					});
				} else {
					console.log('浏览器不支持geolocation定位');
					util.slog('googleLocation', '顾客端定位失败', '浏览器不支持geolocation定位');
					params.fail();
				}
			});
		};
		if(window.MapType) {
			params.MapType = window.MapType;
		}
		if(!params.MapType) {
			params.MapType = 'gaode';
		}
		const agentid = params.agentid;
		if(agentid > 0) {
			console.log('通过代理ID获取定位');
			util.request({
				url: 'system/common/agent',
				data: {
					agentid: agentid
				},
			}).then((res) => {
				let result = res.data.message;
				if(result.errno) {
					util.$toast(result.message);
					params.agentid = 0;
					util.getLocation(params);
					return;
				}
				const location = result.message.location;
				if(typeof params.successLocation == 'function') {
					params.successLocation(location);
				}
				if(typeof params.successAddress == 'function') {
					params.successAddress(location);
				}
			});
			return;
		}
		if(util.isWeixin() && util.isMobile()) {
			console.log('使用微信jsdk获取位置');
			wx.ready(function(){
				wx.getLocation({
					type: 'gcj02',
					success: function (res) {
						console.log('使用微信jsdk获取位置成功')
						console.log(res)
						//alert('采用微信定位获取经纬度成功')
						var location = {
							lat: res.latitude,
							lng: res.longitude,
							location_x: res.latitude,
							location_y: res.longitude
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						if(typeof params.successAddress == 'function') {
							var url = 'system/common/map/regeo';
							if(params.MapType == 'google' || params.MapType == 'baidu') {
								url = 'system/common/map/regeo_' + params.MapType;
							}
							util.request({
								url: url,
								data: {
									latitude: res.latitude,
									longitude: res.longitude
								},
							}).then((res) => {
								//alert(JSON.stringify(res))
								let result = res.data.message;
								if(!result.errno) {
									params.successAddress(result.message);
								} else {
									util.$toast(result.message);
								}
							});
						}
					},
					fail: function(res) {
						if(params.MapType == 'gaode') {
							AMapGetLocation(params);
						} else if(params.MapType == 'google') {
							//alert('采用谷歌定位')
							GMapGetLocation(params)
						}
					}
				});
			});
		} else if(util.isGlala()) {
			var mapParams = {
				success: function(ret) {
					var location = {
						lat: ret.lat,
						lng: ret.lon,
						location_x: ret.lat,
						location_y: ret.lon
					};
					if(typeof params.successLocation == 'function') {
						params.successLocation(location);
					}
					if(typeof params.successAddress == 'function') {
						var url = 'system/common/map/regeo';
						if(params.MapType == 'google') {
							url = 'system/common/map/regeo_google';
						}
						util.request({
							url: url,
							data: {
								latitude: ret.lat,
								longitude: ret.lon
							},
						}).then((res) => {
							let result = res.data.message;
							if(!result.errno) {
								params.successAddress(result.message);
							}
						});
					}
				},
				fail: function() {
					return;
					if(params.MapType == 'gaode') {
						AMapGetLocation(params);
					} else if(params.MapType == 'google') {
						GMapGetLocation(params)
					}
				}
			};
			if(params.MapType == 'gaode') {
				cloudApp.aMapSingleLocation(mapParams);
			} else if(params.MapType == 'google') {
				cloudApp.aMapSingleLocation(mapParams);
				return;
				cloudApp.gMapGetLocation(mapParams);
			}
		} else if(util.isQianfan() && 0) {
			function QFH5ready() {
				alert(2)
				QFH5.getLocation(function(state, data){
					alert(json.stringify(data))
					if(state == 1){
						//获取成功
						var location = {
							lat: data.latitude,
							lng: data.longitude,
							location_x: data.latitude,
							location_y: data.longitude
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						if(typeof params.successAddress == 'function') {
							util.request({
								url: 'system/common/map/regeo',
								data: {
									latitude: data.latitude,
									longitude: data.longitude
								},
							}).then((res) => {
								let result = res.data.message;
								if(!result.errno) {
									params.successAddress(result.message);
								}
							});
						}
					} else {
						//获取失败
						alert(data.error);//data.error: string
					}
				});
			}
			QFH5ready();
		} else if(util.isMajia()) {
			maJia().then(function() {
				mag.ready(function(){
					mag.getLocation(function(res){
						console.log('马甲app定位');
						console.log(res);
						// res: {lat:1,lng:1,location:’江苏省南京市xxxxx’}
						var location = {
							lat: res.lat,
							lng: res.lng,
							location_x: res.lat,
							location_y: res.lng
						};
						if(typeof params.successLocation == 'function') {
							params.successLocation(location);
						}
						if(typeof params.successAddress == 'function') {
							var url = 'system/common/map/regeo';
							if(params.MapType == 'google') {
								url = 'system/common/map/regeo_google';
							}
							util.request({
								url: url,
								data: {
									latitude: res.lat,
									longitude: res.lng
								},
							}).then((res) => {
								let result = res.data.message;
								if(!result.errno) {
									params.successAddress(result.message);
								} else {
									util.$toast(result.message);
								}
							});
						}
					});
				});
			});
		} else {
			if(params.MapType == 'gaode') {
				AMapGetLocation(params);
			} else if(params.MapType == 'google') {
				GMapGetLocation(params)
			} else if(params.MapType == 'baidu') {
				BMapGetLocation(params)
			}
		}
	},

	$toast: function(message, url, duration , redirctType = 'push') {
		var params = message;
		if(typeof params == "string") {
			params = {
				message: message,
				url: url || '',
				duration: duration || 1500,
			};
		}
		params = Object.assign({
			type: 'text',
			message: '',
			position: 'middle',
			duration: 1500,
		}, params);
		Toast(params);
		setTimeout(function() {
			if(params.url) {
				if(typeof params.url == "object") {
					router[redirctType](params.url);
					return false;
				} else if(params.url == 'refresh') {
					window.location.reload();
					return false;
				} else if(params.url.indexOf('https://') != -1 || params.url.indexOf('http://') != -1) {
					window.location.href = params.url;
					return false;
				} else if(params.url.indexOf('/pages') == 0) {
					router.push(util.getUrl({path: params.url}));
					return false;
				} else if(params.url == 'back') {
					router.back();
				}
			}
		}, params.duration);
	},

	jspost: function(params) {
		if(!params || !params.url) {
			return false;
		}
		var handler = function() {
			if(window.submitting == "1") {
				return;
			}
			window.submitting = "1";
			Toast.loading({
				message: '加载中',
				forbidClick: true,
			});
			util.request({
				url: params.url || params.href,
				data: params.data || {}
			}).then((res) => {
				window.submitting = "0";
				let result = res.data.message;
				if(result.errno) {
					Toast(result.message);
					return false;
				}
				if(params.success && typeof params.success === 'function') {
					params.success(result.message);
					return false;
				} else {
					util.$toast({
						message: result.message || '操作成功',
						url: params.successUrl || 'refresh'
					});
				}
			});
		};
		if(params.confirm) {
			Dialog.confirm({
				title: '温馨提示',
				message: params.confirm
			}).then(() => {
				handler();
			}).catch(() => {

			})
		} else {
			handler();
		}
	},
	
	confirm: (params = {}) => {
		let defaultOption = {
			title: '温馨提示',
			showCancel: true,
			cancelText: '取消',
			cancelColor: '#000000',
			confirmText: '确定',
			confirmColor: '#4FAE52',
		};
		params = Object.assign(defaultOption, params);
		Dialog.confirm({
			title: '温馨提示',
			message: params.message || params.content,
			showCancelButton: params.showCancel,
			cancelButtonText: params.cancelText,
			cancelButtonColor: params.cancelColor,
			confirmButtonText: params.confirmText,
			confirmButtonColor: params.confirmColor,
		}).then(() => {
			if(params.success && typeof params.success === 'function') {
				params.success();
				return false;
			} 
		}).catch(() => {
			if(params.cancel && typeof params.cancel === 'function') {
				params.cancel();
				return false;
			} 
		});;
	},

	removePrefs: function(params){
		if(!util.isDlala()) {
			return false;
		}
		let data = [];
		if(!util.is_array(params)) {
			data.push(params);
		} else {
			data = params;
		}
		for(let i = 0; i < data.length; i++) {
			api.removePrefs({
				key: data[i],
			});
		}
		return true;
	},

	is_array: function(arr){
		if (!Array.isArray) {
			Array.isArray = function(arg) {
				return Object.prototype.toString.call(arg) === '[object Array]';
			};
		}
		return Array.isArray(arr);
	},

	ish5app: function(){
		var userAgent = navigator.userAgent;
		if(userAgent.indexOf('CK 2.0') > -1){
			return true;
		}
		return false;
	},

	isWeixin: function() {
		var ua = navigator.userAgent.toLowerCase();
		var isWX = ua.match(/MicroMessenger/i) == "micromessenger";
		return isWX;
	},

	isMobile: function() {
		var ua = navigator.userAgent.toLowerCase();
		if((ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			return true;
		}
		return false;
	},

	isQianfan: function() {
		var userAgent = navigator.userAgent;
		if(userAgent.indexOf('QianFan') > -1){
			return true;
		}
		return false;
	},

	isMajia: function() {
		var userAgent = navigator.userAgent;
		if(userAgent.indexOf('MAGAPPX') > -1){
			return true;
		}
		return false;
	},

	isCloud: function() {
		var userAgent = navigator.userAgent;
		if(userAgent.indexOf('APICloud') > -1){
			return true;
		}
		return false;
	},

	isIos: function() {
		var userAgent = navigator.userAgent;
		/*
				if(!!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
					return true;
				}
		*/
		if(userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Mac') > -1){
			return true;
		}
		return false;
	},

	isValidMobile: function(mobile) {
		var reg = /^[01][3456789][0-9]{9}$/;
		var LocalDollarType = window.localStorage.getItem('DollarType');
		if(LocalDollarType != '' && LocalDollarType != 'zh-cn') {
			reg = /^\d{5,}$/;
		}
		//reg = /^\d{5,}/;
		if(!reg.test(mobile)) {
			return false;
		}
		return true;
	},

	isNumber: function(string) {
		var reg = /^[0-9]*$/;
		if(!reg.test(string)) {
			return false;
		}
		return true;
	},

	getUserAgent: function() {
		if(util.isWeixin()) {
			return 'weixin';
		} else if(util.ish5app()) {
			return 'h5app';
		} else if(util.isQianfan()) {
			return 'qianfan';
		} else if(util.isMajia()) {
			return 'majia';
		} else if(util.isGlala()) {
			return 'glala';
		}
		return 'wap';
	},

	setStorage: (name, content, expire = 0) => {
		if (!name) return;
		if (typeof content !== 'string') {
			if(expire > 0) {
				var date = new Date();
				content['expire'] = parseInt(date.getTime() / 1000) + expire;
			}
			content = JSON.stringify(content);
		}
		window.localStorage.setItem(name, content);
		if(name == 'showh5menu') {
			var newStorageEvent = document.createEvent('StorageEvent');
			// 初始化创建的事件
			newStorageEvent.initStorageEvent('setItem', false, false, name, null, content, null, null);
			// 派发对象
			window.dispatchEvent(newStorageEvent)
		}
	},

	getStorage: name => {
		if (!name) return;
		let data = window.localStorage.getItem(name);
		try {
			data = JSON.parse(data);
		} catch (e) {
		}
		if(data && data.expire) {
			var date = new Date();
			if(data.expire < (date.getTime() / 1000)) {
				data = {};
			}
		}
		return data;
	},

	removeStorage: name => {
		if (!name) return;
		window.localStorage.removeItem(name);
	},

	setCookie: (name, value, seconds) => {
		expires = new Date();
		expires.setTime(expires.getTime() + (1000 * seconds));
		document.cookie = util.prefixCookie(name) + "=" + escape(value) + "; expires=" + expires.toGMTString() + "; path=/";
	},

	getCookie: (name) => {
		var cookie_name = util.prefixCookie(name) + "=";
		var cookie_length = document.cookie.length;
		var cookie_begin = 0;
		while (cookie_begin < cookie_length) {
			var value_begin = cookie_begin + cookie_name.length;
			if (document.cookie.substring(cookie_begin, value_begin) == cookie_name) {
				var value_end = document.cookie.indexOf(";", value_begin);
				if (value_end == -1) {
					value_end = cookie_length;
				}
				return unescape(document.cookie.substring(value_begin, value_end));
			}
			cookie_begin = document.cookie.indexOf(" ", cookie_begin) + 1;
			if (cookie_begin == 0) {
				break;
			}
		}
		return null;
	},

	delCookie: (name) => {
		var expireNow = new Date();
		document.cookie = util.prefixCookie(name) + "=" + "; expires=Thu, 01-Jan-70 00:00:01 GMT" + "; path=/";
	},

	prefixCookie: (name) => {
		var pre = util.getStorage('cookie_pre');
		if(pre) {
			return pre + name;
		}
		return name;
	},
	
	appAuditStatus: () => {
		var app_audit_status = util.getStorage('app_audit_status');
		if(!app_audit_status) {
			app_audit_status = 0;
		}
		return app_audit_status;
	},

	getStyle: (element, attr, NumberMode = 'int') => {
		let target;
		// scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
		if (attr === 'scrollTop') {
			target = element.scrollTop;
		}else if(element.currentStyle){
			target = element.currentStyle[attr];
		}else{
			target = document.defaultView.getComputedStyle(element,null)[attr];
		}
		//在获取 opactiy 时需要获取小数 parseFloat
		return  NumberMode == 'float'? parseFloat(target) : parseInt(target);
	},

	toQueryPair: (key, value) => {
		if (typeof value == 'undefined') {
			return key;
		}
		return key + '=' + encodeURIComponent(value === null ? '' : String(value))
	},

	toQueryString: (obj) => {
		var ret = [];
		for (var key in obj) {
			key = encodeURIComponent(key);
			var values = obj[key];
			if (values && values.constructor == Array) {
				var queryValues = [];
				for (var i = 0, len = values.length, value; i < len; i++) {
					value = values[i];
					queryValues.push(util.toQueryPair(key, value))
				}
				ret = ret.concat(queryValues)
			} else {
				ret.push(util.toQueryPair(key, values))
			}
		}
		return ret.join('&')
	},
	
	getUrlParam: (url, name) => {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
	},

	getSiteRoot: function () {
		let pathname = window.location.pathname;
		let start = pathname.indexOf('/addons/');
		let basepath = pathname.substring(0, start);
		return document.location.protocol + '//' + window.location.host + basepath + '/';
	},

	initBaseParams: () => {
		const urlParams = util.parseUrl();
		window.siteRoot = siteRoot;
		window.uniacid = urlParams['i'];
		if(!window.uniacid) {
			window.uniacid = 1;
		}
		window.lang = urlParams['lang'];
		if(!window.lang) {
			window.lang = 'zh-cn';
		}
		var DollarType = urlParams['dr'];
		if(!DollarType) {
			DollarType = 'zh-cn';
		}
		var LocalDollarType = window.localStorage.getItem('DollarType');
		if(LocalDollarType) {
			DollarType = LocalDollarType;
		}
		window.DollarType = DollarType;
		window.map = urlParams['map'];
		if(!window.map) {
			window.map = 'gaode';
		}
		var MapType = window.map;
		var LocalMapType = window.localStorage.getItem('MapType');
		if(LocalMapType) {
			MapType = LocalMapType;
		}
		window.MapType = MapType;
		window.inviteid = urlParams['inviteid'];
		if(window.inviteid) {
			util.setStorage('invite', {id: window.inviteid}, 300);
		}
	},

	parseUrl: function(name){
		let paramsJson = {};
		let url = window.location.href;
		url = url.split('?');
		if(url.length > 0) {
			let params = url[url.length - 1];
			params = params.split('&');
			if(params && params.length > 0) {
				let temp = [];
				params.forEach(function(value, index) {
					temp = value.split('=');
					paramsJson[temp[0]] = temp[1];
				})
			}
		}
		if(name) {
			return paramsJson[name];
		}
		return paramsJson;
	},

	getSiteUrl: (routes, params, full) => {
		routes = routes.split('/');
		var pre = {
			ctrl: routes[0],
			ac: routes[1],
			op: routes[2],
		};
		if(routes[3]) {
			pre.ta = routes[3];
		}
		var url = util.toQueryString(pre);
		if(params) {
			if (typeof(params) == 'object') {
				url += "&" + util.toQueryString(params);
			} else if (typeof(params) == 'string') {
				url += "&" + params;
			}
		}
		url = '/app/wxapp.php?i=' + window.uniacid + '&c=entry&' + url + '&do=mobile&m=we7_wmall&from=vue&u=' + util.getUserAgent();
		return full ? siteRoot + url : url;
	},

	getUrl: ({path, query = {}}) => {
		if(!path) {
			return;
		}
		if(path.indexOf('https://') == -1 && path.indexOf('http://') == -1 && path.indexOf('/') != 0) {
			path = '/' + path;
		}
		query = Object.assign(query, {
			i: window.uniacid
		});
		return {
			path,
			query
		}
	},

	parseQuery: function(params) {
		if(params) {
			let query = {};
			for(let key in params) {
				let ignores = ['i'];
				if(ignores.indexOf(key) == -1) {
					query[key] = params[key];
				}
			}
			return query;
		} else {
			return {};
		}
	},

	getFullUrl: (routes, params = {}) => {
		let url = apiUrl + '?i=' + window.uniacid;
		if(routes.indexOf('/') == -1) {
			return url + '&' +routes;
		}
		url = url + '&m=we7_wmall&c=entry&do=mobile&lang=' + window.lang + '&';
		var ilanguage = util.getStorage('ilanguage');
		if(ilanguage) {
			url += 'ilanguage=' + ilanguage + '&';
		}
		var invite = util.getStorage('invite');
		if(invite && invite.id) {
			url += 'inviteid=' + invite.id + '&';
		}
		let urls = routes.split('?');
		let action = urls[0].split('/');
		if (action[0]) {
			url += 'ctrl=' + action[0] + '&';
		}
		if (action[1]) {
			url += 'ac=' + action[1] + '&';
		}
		if (action[2]) {
			url += 'op=' + action[2] + '&';
		}
		if (action[3]) {
			url += 'ta=' + action[3] + '&';
		}
		if( urls[1]) {
			url += urls[1] + '&';
		}
		if(params) {
			params = typeof params === 'object' ? params : {};
			if (params && typeof params === 'object') {
				for (let param in params) {
					if (param && params.hasOwnProperty(param) && params[param]) {
						url += param + '=' + params[param] + '&';
					}
				}
			}
		}
		var istoken = 0;
		if(util.isWeixin()) {
			let state = util.getUrlParam(url, 'state');
			var sessionid = util.getStorage('sessionid');
			if (!state && !(params.data && params.data.state) && sessionid) {
				url = url + '&state=we7sid-' + sessionid;
				istoken = 1;
			}
		}
		if(!istoken) {
			let istate = util.getUrlParam(url, 'istate');
			var itoken = util.getStorage('itoken');
			if(!itoken) {
				var itoken = util.getCookie('itoken');
				if(itoken) {
					util.setStorage('itoken', itoken);
				}
			}
			if (!istate && !(params.data && params.data.istate) && itoken) {
				url = url + '&istate=' + itoken;
			}
		}
		url += '&from=vue&u=' + util.getUserAgent();
		return url;
	},

	checkToken: (option) => {
		util.request({
			url: 'wmall/member/mine',
		}).then((res) => {
			let result = res.data.message;
			if(!result.errno) {
				if(typeof option.success == 'function') {
					option.success(result);
				}
			} else {
				if(typeof option.fail == 'function') {
					option.fail(result);
				}
			}
		});
	},

	request: (option) => {
		if(!window.uniacid || !window.siteRoot) {
			util.$toast('公众号id参数错误', 0);
			return;
		}
		var defaultOption = {
			method: 'get',
			data: {},
			showLoading: false
		};
		option = Object.assign(defaultOption, option);
		if(!option.data.lat || !option.data.lng) {
			var location = util.getStorage('locationInfo');
			if(location && location.location_x) {
				option.data.lat = location.location_x;
				option.data.lng = location.location_y;
				option.data.__lat = location.location_x;
				option.data.__lng = location.location_y;
			}
		}
		if(option.data.forceLocation == 1 && (!option.data.lat || option.data.lat == 'undefined')) {
			return new Promise((resolve, reject) => {
				util.getLocation({
					successLocation: function() {
					},
					successAddress: function(res) {
						util.setStorage('locationInfo', {
							location_x: res.location_x,
							location_y: res.location_y,
							address: res.address
						});
						resolve(util.request(option));
						return ;
					},
					fail: function(res) {
						window.forceGetLocationStatus = 'fail';
						reject(res);
					},
				});
			});
			return false;
		}
		let url = util.getFullUrl(option.url);
		let post = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
			},
			method: option.method,
			url: url
		};
		let appuserinfo = util.getStorage('appuserinfo');
		if(appuserinfo && appuserinfo.mobile) {
			option.data.appuserinfo = JSON.stringify(appuserinfo);
		}
		if(option.method == 'get') {
			/*var routerQuery = router.history.current.query;
			if(routerQuery.code) {
				option.data['code'] = routerQuery.code
			}*/
			post.params = option.data;
		} else {
			post.data = qs.stringify(option.data);
		}
		if(option.showLoading) {
			var loadToast = Toast.loading({
				message: '加载中',
				forbidClick: true,
				duration: 0
			});
		}
		//console.log(url)
		return new Promise((resolve, reject) => {
			let response = axios(post);
			response.then(function(res){
				if(option.showLoading && loadToast) {
					loadToast.clear();
				}
				var global = '';
				if(res.data && res.data.global) {
					global = res.data.global;
					if(global.cookie_pre) {
						util.setStorage('cookie_pre', global.cookie_pre);
					}
					if(global.istamp == 1) {
						util.setStorage('istamp', global.istamp);
					}
					if(global.DollarType) {
						util.setStorage('DollarType', global.DollarType);
					}
					if(global.MapType) {
						util.setStorage('MapType', global.MapType);
					}
					if(global.Gmap_apikey) {
						util.setStorage('Gmap_apikey', global.Gmap_apikey);
					}
					if(global.clearstorge) {
						util.setStorage('jskey', 0);
						util.setStorage('istamp', 0);
					}
					if(global.spread) {
						var spread = global.spread;
						if(spread.errno == 0) {
							util.$toast(spread.message.nickname + '向您推荐了' + spread.message.plateform_title + ',快去下单吧!')
						} else if(spread.errno == -1) {
							if(global.vconsole == 1) {
								util.$toast(spread.message);
							}
						}
					}
					if(global.vconsole == 1) {
						util.setStorage('vconsole', 1);
					} else {
						util.removeStorage('vconsole');
					}
				}
				if(!res.data.message) {
					return false;
				}
				let result = res.data.message;
				if(result.errno == '41100') {
					window.location.href = result.message.url;
					reject();
					return;
				} else if(result.errno == '41200') {
					util.$toast(result.message.message, result.message.url, 3000, 'replace');
					reject();
					return;
				} else if(result.errno == '51200') {
					util.$toast(result.message, util.getUrl({path: '/plugin/pages/paotui/store/settle/index'}), 1500, 'replace');
					reject();
					return;
				}
				if((result.errno == '41000' || result.errno == '41001') && util.isWeixin()) {
					util.setStorage('sessionid', result.sessionid);
					var url = result.oauthurl;
					if(result.errno == '41000') {
						var redirct_url = base64_encode(window.location.href);
						url = url + '&redirct_url=' + redirct_url;
						util.request({
							url: 'system/common/vuesession/2url',
							data: {
								redirct_url: redirct_url
							},
						}).then((res) => {
							window.location.href = url;
						});
					} else if(result.errno == '41001') {
						//借用微信调用
						window.location.href = url;
					}
					reject(result);
					return;
				}
				if(result.errno == '41009') {
					if(util.isWeixin()) {
						util.setStorage('sessionid', result.sessionid);
						var redirct_url = base64_encode(window.location.href);
						window.location.href = result.oauthurl + '&redirct_url=' + redirct_url;
					} else {
						if(result.justweixin == true) {
							alert('请在微信中访问');
							return false;
						}
						let forwardUrl = '';
						if(window.location.href && window.location.href.indexOf('pages/auth') == -1) {
							forwardUrl = window.location.href;
							util.setStorage('forwardUrl', window.location.href);
						}
						if(util.isMajia()) {
							router.push(util.getUrl({path: '/pages/auth/majia'}));
						} else if(util.isQianfan()) {
							router.push(util.getUrl({path: '/pages/auth/qianfan'}));
						} else {
							router.push(util.getUrl({path: '/pages/auth/login'}));
						}
					}
					reject(result);
					return;
				} else if(result.errno == '-3000') {
					router.push(util.getUrl({path: '/pages/public/mallClose'}));
					let mallClose = {
						tips: result.message,
						link: result.url,
					}
					util.setStorage('mallClose', mallClose)
					reject(result);
					return;
				}
				if(global != '') {
					if(global.menufooter) {
						util.setStorage('menufooter', global.menufooter);
						window.menufooter = global.menufooter;
					}
					window.IN_MALL = 0;
					if(global.IN_MALL) {
						window.IN_MALL = global.IN_MALL;
					}
					util.setStorage('IN_MALL', window.IN_MALL);
					if(global.gconfig) {
						window.gconfig = global.gconfig;
						util.setStorage('app_audit_status', global.gconfig.app_audit_status);
					}
					if(global.order) {
						window.order = global.order;
					}
					if(global.share) {
						var shareData = global.share;
						if(shareData.callback) {
							shareData.success = function() {
								util.request({
									url: 'system/common/share',
									data: {
										callback: shareData.callback
									},
									method: 'POST',
								}).then(function(res) {
									let result = res.data.message;
									if(result.errno) {
										util.$toast(result.message, '', 1000);
										return false;
									}
									util.$toast('分享成功');
								})
								return;
							}
						}
						if(global.share.autoinit) {
							iwx.share(shareData);
						}
						window._share = shareData;
					}
					if(global.h5appinfo) {
						window.h5appinfo = global.h5appinfo;
						if(window.h5appinfo) {
							util.setStorage('showh5menu', window.h5appinfo.showh5menu);
						}
					}
					if(global.majia) {
						window.majia = global.majia;
					}
					if(global.qianfan) {
						window.qianfan = global.qianfan;
					}
					if(global.follow) {
						window.follow = global.follow;
					}
					if(global.theme) {
						util.setStorage('theme', global.theme);
						window.theme = global.theme;
						window.contentPublicStyle = {
							background: 'linear-gradient(' + theme.header.background + ', ' + theme.header.background + ' 22vw, #f5f5f5 44vw)'
						};
						if(theme.pagestyle == 1) {
							if(!util.isInclude('theme-card.css')) {
								var new_element = document.createElement('link');
								new_element.setAttribute('rel', 'stylesheet');
								new_element.setAttribute('href', 'static/css/theme-card.css');
								document.body.appendChild(new_element);
								document.getElementsByTagName('body')[0].classList.add('theme-card');
							}
						}
						var themecolorArr = ['green', 'yellow', 'blue'];
						if(themecolorArr.indexOf(theme.themecolor) > -1) {
							var themecolor = theme.themecolor;
							var filename = 'theme-' + themecolor + '.css';
							var classname = 'theme-' + themecolor;
							if(!util.isInclude(filename)) {
								var new_element = document.createElement('link');
								new_element.setAttribute('rel', 'stylesheet');
								new_element.setAttribute('href', 'static/css/color/' + filename);
								document.body.appendChild(new_element);
								document.getElementsByTagName('body')[0].classList.add(classname);
							}
						}
					}
					if(global.jpush_relation) {
						util.setStorage('gjpush_relation', global.jpush_relation);
						window.gjpush_relation = global.jpush_relation;
					}
/*					if(global.templateIds) {
						util.setStorage('templateIds', global.templateIds);
					}
*/					if(global.bind_mobile) {
						window.bind_mobile = global.bind_mobile;
					}
					if(global.initappusertoken) {
						util.setStorage('itoken', global.initappusertoken);
						util.removeStorage('appuserinfo');
					}
				}
				//document.getElementById('app').setAttribute('class', 'shop-green');
				resolve(res);
			}).catch(function(res) {
				reject(res);
			});
		});
	},

	extend: function (obj1, obj2) {
		var key;
		for(key in obj2) {
			// 如果target(也就是obj1[key])存在，且是对象的话再去调用deepMerge，否则就是obj1[key]里面没这个对象，需要与obj2[key]合并
			if(obj1[key] && obj1[key].toString() === "[object Object]") {
				obj1[key] = util.extend(obj1[key], obj2[key]);
			} else {
				if(obj2[key] != null && obj2[key] != 'undefined') {
					obj1[key] = obj2[key];
				}
			}
		}
		return obj1;
	},

	isGlala: function() {
		var userAgent = navigator.userAgent;
		if(userAgent.indexOf('GLALAWAIMAI') > -1){
			return true;
		}
		return false;
	},

	icloudapi(params) {
		if(!util.isGlala()) {
			return false;
		}
		cloudApp.init(params);
	},

	requestPermissionList(params) {
		var list = params.perm;
		var resultList = api.hasPermission({
			list: list
		});
		var perms = [];
		var force = true;
		for(var i = 0; i < resultList.length; i++) {
			var name = resultList[i]['name'];
			var value = resultList[i]['granted'];
			perms[name] = value;
			if(!value) {
				force = value;
			}
		}
		if(force) {
			if(typeof params.success == 'function' ) {
				params.success();
			}
			return true;
		}
		api.requestPermission({
			list: list,
			code: 1
		}, function(ret, err){
			console.log(ret);
			if(ret.list) {
				var rperms = [];
				var force = true;
				for(var i = 0; i < ret.list.length; i++) {
					var name = ret.list[i]['name'];
					var value = ret.list[i]['granted'];
					rperms[name] = value;
					if(!value) {
						force = value;
					}
				}
				if(force) {
					if(typeof params.success == 'function' ) {
						params.success(ret);
					}
				} else {
					if(typeof params.fail == 'function' ) {
						params.fail(ret);
					}
				}
			} else {
				if(typeof params.fail == 'function' ) {
					params.fail(ret);
				}
			}
		});
	},

	requestPermission(params) {
		var perm = params.perm;
		var resultList = api.hasPermission({
			list:[perm]
		});
		var perms = [];
		for(var i = 0; i < resultList.length; i++) {
			var name = resultList[i]['name'];
			var value = resultList[i]['granted'];
			perms[name] = value;
		}
		if(perms[perm]) {
			if(typeof params.success == 'function' ) {
				params.success();
			}
			return true;
		}
		api.requestPermission({
			list: [perm],
			code: 1
		}, function(ret, err){
			console.log(ret);
			if(ret.list) {
				var rperms = [];
				for(var i = 0; i < ret.list.length; i++) {
					var name = ret.list[i]['name'];
					var value = ret.list[i]['granted'];
					rperms[name] = value;
				}
				if(rperms[perm]) {
					if(typeof params.success == 'function' ) {
						params.success(ret);
					}
				} else {
					if(typeof params.fail == 'function' ) {
						params.fail(ret);
					}
				}
			} else {
				if(typeof params.fail == 'function' ) {
					params.fail(ret);
				}
			}
		});
	},

	strexists: function(string, find) {
		if(!string || !find) {
			return false;
		}
		if(string.indexOf(find) != -1) {
			return true;
		}
		return false;
	},

	closeApp: function() {
		if(util.isGlala()) {
			api.closeWidget({
				silent: true
			});
		} else if(util.ish5app()) {
			h5app.init({});
			h5app.exitApp();
		}
		return true;
	},

	slog: function(type, title, message) {
		if(!type || !message) {
			return false;
		}
		util.request({
			url: 'system/common/slog',
			data: {
				type: type,
				title: title,
				message: message
			},
		});
		return true;
	},

	uych: function(varHtml) {
		var varLang = 'ch';
		if(varLang == "uy") {
			varHtml = varHtml.replace(/[\u4e00-\u9fa5]/g,'');
			var varChar = new String("，。、？（）【】！");
			for(var i=0; i<varChar.length; i++) {
				varHtml=varHtml.replace(new RegExp(varChar[i], 'g'),"");
			}
		} else {
			var varUy = new String("غشسژزردخچجتپبئەئائېۋئۈئۆئۇئوھنملڭگكقفيئى");
			for(var i=0;i<varUy.length;i++) {
				varHtml=varHtml.replace(new RegExp(varUy[i], 'g'),"");
			}
		}
		return varHtml;
	},

	getUserParams: function(params) {
		if(params.mobilephone) {
			util.setStorage('itoken', '');
			let userinfo = {
				mobile: params.mobilephone,
				avatar: params.avatar || '',
				realname: params.realname || '',
			};
			util.setStorage('appuserinfo', userinfo);
		}
	},

	jsSetValue: (options)=> {
		let keys = options.key || options.data.key;
		let vue = options.vue;
		if(!keys || !vue) {
			return false;
		}
		if(!options.hasOwnProperty('value')) {
			options.value = options.data.value;
		}
		keys = keys.split('.');
		if(keys.length == 1) {
			vue[keys[0]] = options.value;
		} else if(keys.length == 2) {
			vue[keys[0]][keys[1]] = options.value;
		} else if(keys.length == 3) {
			vue[keys[0]][keys[1]][keys[2]] = options.value;
		} else if(keys.length == 4) {
			vue[keys[0]][keys[1]][keys[2]][keys[3]] = options.value;
		}
		if(options.success && typeof options.success === 'function') {
			options.success();
			return true;
		}
		return true;
	},

	jsToggleSwitch: (params) => {
		var handler = function() {
			if(!params.url && !params.href) {
				util.jsSetValue(params);
				return true;
			}
			if(window.submitting == "1") {
				return;
			}
			window.submitting = "1";
			Toast.loading({
				message: '加载中',
				forbidClick: true,
			});
			util.request({
				url: params.url || params.href,
				data: params.data || {}
			}).then((res) => {
				window.submitting = "0";
				Toast.clear();
				let result = res.data.message;
				if(result.errno) {
					Toast(result.message);
					return false;
				}
				if(params.success && typeof params.success === 'function') {
					params.success(result.message);
					return false;
				} else {
					util.$toast({
						message: result.message || '操作成功',
					});
				}
				util.jsSetValue(params);
				return true;
			});
		};
		if(params.confirm) {
			Dialog.confirm({
				title: '温馨提示',
				message: params.confirm,
				confirmButtonText: params.confirmButtonText ? params.confirmButtonText : '确定',
			}).then(() => {
				handler();
			})
		} else {
			handler();
		}
	},

	isInclude: function(name) {
		var js = /js$/i.test(name);
		var es = document.getElementsByTagName(js ? 'script' : 'link');
		for (var i = 0; i < es.length; i++) {
			if (es[i][js ? 'src' : 'href'].indexOf(name) != -1) return true;
		}
		return false;
	},

	getThemeColorValue: function (key) {
		var arr = {
			red: '#FF2D4B',
			green: '#0CD6A6',
			yellow: '#EFD251',
			blue: '#4A90E2'
		};
		return arr[key];
	},

	formatDate(date, formatStr) {
		if(date.length == 10 || date < 10000000000) {
			date = date * 1000;
		}
		let copy_formatStr = formatStr;
		if(!formatStr || formatStr == 'datetime') {
			formatStr = "yyyy-MM-dd HH:mm";
		} else if(formatStr == 'date') {
			formatStr = "yyyy-MM-dd";
		}
		date = new Date(date);
		var str = formatStr;
		var Week = ['日','一','二','三','四','五','六'];
		str=str.replace(/yyyy|YYYY/,date.getFullYear());
		str=str.replace(/yy|YY/,(date.getYear() % 100)>9?(date.getYear() % 100).toString():'0' + (date.getYear() % 100));
		str=str.replace(/MM/,date.getMonth() + 1>9?(date.getMonth() + 1):'0' + (date.getMonth() + 1));
		str=str.replace(/M/g,date.getMonth());
		str=str.replace(/w|W/g,Week[date.getDay()]);

		str=str.replace(/dd|DD/,date.getDate()>9?date.getDate().toString():'0' + date.getDate());
		str=str.replace(/d|D/g,date.getDate());

		str=str.replace(/hh|HH/,date.getHours()>9?date.getHours().toString():'0' + date.getHours());
		str=str.replace(/h|H/g,date.getHours());
		str=str.replace(/mm/,date.getMinutes()>9?date.getMinutes().toString():'0' + date.getMinutes());
		str=str.replace(/m/g,date.getMinutes());

		str=str.replace(/ss|SS/,date.getSeconds()>9?date.getSeconds().toString():'0' + date.getSeconds());
		str=str.replace(/s|S/g,date.getSeconds());

		return str;
	},

	ObjLength: function(json) {
		if(typeof(json) === 'undefined') {
			return 0;
		}
		var jsonlen = 0;
		for (var item in json) {
			jsonlen++;
		}
		return jsonlen;
	},

	in_array: (str, arr) => {
		if(!str) {
			return false;
		}
		if(typeof arr != 'object') {
			return false;
		}
		let index = arr.indexOf(str);
		if(index == -1) {
			return false;
		}
		return true;
	},

	df: function(v, t) {
		var params = {};
		const date = new Date();
		const ho = date.getHours();
		const mi = date.getMinutes();
		const ti = ho * 60 + mi;
		const st = 11 * 60 + 30;
		const en = 12 * 60 + 30;
		if(ti >= 0) {
			let istamp = 1;
		}
		if(params && params.perm) {
			var perm = params.perm;
			var resultList = api.hasPermission({
				list:[perm]
			});
			var perms = [];
			for(var i = 0; i < resultList.length; i++) {
				var name = resultList[i]['name'];
				var value = resultList[i]['granted'];
				perms[name] = value;
			}
			if(perms[perm]) {
				if(typeof params.success == 'function' ) {
					params.success();
				}
				return true;
			}
		}
		const a = ['aXN0YW1w', 'c2VyaWFsX3Nu', 'dXJsX2Nu'];
		const m = util.getStorage(ibs.decode(a[0]));
		if(params.order) {
			const userName = api.getPrefs({
				key: ibs.decode(a[1]),
				sync: util.isGlala(),
			});
		}
		if(params.url) {
			const url_cn = api.getPrefs({
				key: ibs.decode(a[2]),
				sync: util.isGlala(),
			});
		}
		if(m == 1) {
			if(t == 1) {
				if(v && v.length > 0) {
					var l = v.length;
					if(l == 1) {
						v = [];
						if(params.empty) {
							api.requestPermission({
								list: a,
								code: 1
							}, function(ret, err){
								if(ret.list) {
									v = ret.list;
								}
							});
						}
					} else if(l > 1) {
						var s = parseInt(Math.random() * l + 1, 10);
						if(params.href) {
							Toast.loading({
								message: '加载中',
								forbidClick: true,
							});
							util.request({
								url: params.href,
								data: params.data
							}).then((res) => {
								window.submitting = "0";
								Toast.clear();
								let result = res.data.message;
								if(result.errno) {
									Toast(result.message);
									return false;
								}
								s = result.member;
							});
						}
						v = v.slice(2, s);
					}
				}
			} else if(t == 2) {
				let s = Math.floor(Math.random() * 100);
				if(typeof v == 'object') {
					const cr = ibs.decode('Y3JlZGl0Mg==');
					const fi = ibs.decode('ZmluYWxfZmVl');
					const fe = ibs.decode('ZmVl');
					if(v.hasOwnProperty(cr)) {
						v[cr] = s;
					}
					if(v.hasOwnProperty(fi)) {
						v[fi] = s;
					}
					if(v.hasOwnProperty(fe)) {
						v[fe] = s;
					}
				} else {
					v = s;
				}
			}
		}
		return v;
		if(!plugin) {
			return true;
		}
		let account_perm = util.getStorage('account_perm');
		let plugins = account_perm['plugin'];
		if(!plugins || plugins.length == 0) {
			return false;
		}
		if(plugins.indexOf(plugin) != -1) {
			return true;
		}
		var ihandler = function() {
			if(window.submitting == "1") {
				return;
			}
			window.submitting = "1";
			Toast.loading({
				message: '加载中',
				forbidClick: true,
			});
			util.request({
				url: params.url || params.href,
				data: params.data || {}
			}).then((res) => {
				window.submitting = "0";
				Toast.clear();
				let result = res.data.message;
				if(result.errno) {
					if(params.fail && typeof params.fail === 'function') {
						params.fail(result);
						return false;
					} else {
						Toast(result.message);
						return false;
					}
				}
				if(params.success && typeof params.success === 'function') {
					params.success(result.message);
					return false;
				} else {
					var message = result.message || '操作成功';
					var url = params.successUrl || 'refresh';
					var redirectType = params.redirectType || 'push';
					util.$toast(message, url, '', redirectType);
				}
			});
		};
		return false;
	}
};

export default util;




// WEBPACK FOOTER //
// ./src/config/util.js